import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { tap, map } from 'rxjs/operators'; 

interface MyProfileTokenDto {
  token: string;
}

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  private myProfileToken: string | null = null;

  constructor(private http: HttpClient) { }

  /**
   * Recupera il JWT di MyProfile dal backend.
   * Memorizza il token per evitare chiamate ripetute.
   */
  getJwtMyProfile(): Observable<string> {
    if (this.myProfileToken) {
      return of(this.myProfileToken);
    }
    
    return this.http.get<MyProfileTokenDto>(`${environment.urls.base}/gestioneutenti/getjwt`).pipe(
      tap(response => {
        this.myProfileToken = response.token;
     }),
     map(response => response.token) //per convertire la risposta in stringa
    );
  }
}